import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavItem } from '@retailer-platform/dashboard/routing'
import { productsRouter } from './routing/productsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { productsSearchAccessControl } from './access-control/searchAccess.configuration'
import {
  productsViewItemAnomalyAccessControl,
  productsViewMissingCodesAccessControl,
  productsViewLowPriceAlertsAccessControl,
} from './access-control/viewAccess.configuration.ts'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'products',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'products-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES },
  routers: {
    scoped: [productsRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Catalog,
      attachToV2: NavEntryPoint.Catalog,
      subNavItems: [
        {
          type: 'item',
          labelId: 'productsDomain.search.title',
          route: 'products-search',
          accessControl: productsSearchAccessControl,
          positionNavV2: 0,
          inToolPermissions: [
            {
              slug: Permission.ProductsCatalogProductsModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ProductsCatalogProductsModify,
            },
            {
              slug: Permission.ProductAttributesEdit,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ProductAttributesEdit,
            },
            {
              slug: Permission.ProductsRetailerCollectionsV2,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ProductsRetailerCollectionsV2,
            },
          ],
        },
      ],
    },
    {
      attachTo: NavItem.Catalog,
      attachToV2: NavEntryPoint.Catalog,
      subNavItems: [
        {
          type: 'item',
          labelId: 'productsDomain.itemAnomaly.reports.title',
          route: 'item-anomaly-reports',
          accessControl: productsViewItemAnomalyAccessControl,
          positionNavV2: 6,
        },
      ],
    },
    {
      attachTo: NavItem.Catalog,
      attachToV2: NavEntryPoint.Catalog,
      subNavItems: [
        {
          type: 'item',
          labelId: 'productsDomain.missingCodes.title',
          route: 'products-missing-codes',
          accessControl: productsViewMissingCodesAccessControl,
          positionNavV2: 7,
        },
      ],
    },
    {
      attachTo: NavItem.Catalog,
      attachToV2: NavEntryPoint.Catalog,
      subNavItems: [
        {
          type: 'item',
          labelId: 'productsDomain.lowPriceAlert.title',
          route: 'products-low-price-alerts',
          accessControl: productsViewLowPriceAlertsAccessControl,
          positionNavV2: 8,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
